import { Chip } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { memo } from "react";
import { useEventManagerContext } from "../../context/eventContext";
import useEventLock from "../../hooks/useEventLock";

function LockChip() {
  const theme = useTheme();

  const { selectedEvent, isAnEventManagerAdmin } = useEventManagerContext();
  const { unlockTime } = useEventLock();

  if (!selectedEvent || !isAnEventManagerAdmin) return null;

  const { lockForStudents, lockForTeachers } = selectedEvent;

  if (!lockForStudents && !lockForTeachers) return null;

  let label = "";

  if (lockForStudents && lockForTeachers) label = "Alle gesperrt";
  else if (lockForStudents) label = "SuS gesperrt";
  else if (lockForTeachers) label = "LP gesperrt";

  if (unlockTime) {
    const time = new Date(unlockTime).toLocaleTimeString("de-CH", {
      hour: "2-digit",
      minute: "2-digit",
    });
    label += ` bis ${time}`;
  }

  return (
    <Chip
      size="small"
      icon={<Lock sx={{ fontSize: 16 }} />}
      label={label}
      sx={{
        ml: 1,
        bgcolor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        fontWeight: 500,
      }}
    />
  );
}

export default memo(LockChip);
